import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import OrderSettingsMvp from './OrderSettingsMvp';
import PurchaseSubHeaderMvp from './PurchaseSubHeaderMvp';
import { GetFlag } from '../../../utils/featureFlag';
import {
  FEATURE_FLAG_CROSS_SELL_VERTICAL,
  CROSS_SELL_VERTICAL_BREAKPOINT
} from '../../../utils/cross-sell';
import { VerticalCrossSellSidebar } from './ShoppingCartMVP/ShoppingCartWrapper.styles';
import { CrossSellProducts } from './ShoppingCartMVP/CrossSellProducts';
import useIsScreenSmallerThan from '../../../hooks/useIsScreenSmallerThan';
import { LongSteelContainer } from './LongSteelMvp.styles';
import { EOrderSettingsRoutes } from './OrderSettingsMvp/orderSettings.routes';
import { ApplicationState } from '../../../store';
import { useFilteredCrossSellItems } from '../../../services/MVP/useFilteredCrossSellItems';

export const LongSteelMvp = () => {
  const { pathname } = useLocation();
  const crossSellVerticalFlag = GetFlag(FEATURE_FLAG_CROSS_SELL_VERTICAL);
  const isSmallScreen = useIsScreenSmallerThan(CROSS_SELL_VERTICAL_BREAKPOINT);
  const isCartPage = pathname.includes(EOrderSettingsRoutes.SHOPPING_CART);
  const crossSellState = useSelector(
    (appState: ApplicationState) => appState.crossSell
  );
  const filteredCrossSellItems = useFilteredCrossSellItems();

  const hasCrossSellProducts =
    crossSellState.loading || filteredCrossSellItems.length > 0;

  const [crossSellKey, setCrossSellKey] = React.useState('');
  const [autoSyncLoading, setAutoSyncLoading] = React.useState(false);

  const showVertical =
    crossSellVerticalFlag &&
    !isSmallScreen &&
    isCartPage &&
    hasCrossSellProducts;

  return (
    <LongSteelContainer showVerticalCrossSell={showVertical}>
      <PurchaseSubHeaderMvp />
      <OrderSettingsMvp
        crossSellKey={crossSellKey}
        setCrossSellKey={setCrossSellKey}
        autoSyncLoading={autoSyncLoading}
        setAutoSyncLoading={setAutoSyncLoading}
      />
      {showVertical && (
        <VerticalCrossSellSidebar>
          <CrossSellProducts
            setCrossSellKey={setCrossSellKey}
            orientation="vertical"
            filteredItems={filteredCrossSellItems}
            syncLoading={autoSyncLoading}
            title="Sugestões de compra para você"
          />
        </VerticalCrossSellSidebar>
      )}
    </LongSteelContainer>
  );
};
